/**
 * Point-of-sale surface.
 *
 * Rendered shell-less (no sidebar/menu) for users whose only capability is the
 * POS surface (the scoped ``pos`` role) AND mountable on a standalone
 * "POS endpoint display" page. The actual sell flow is the SELF-CONTAINED,
 * admin-chrome-free ``PosSellScreen`` — this page only provides the AntD ``App``
 * context (message/notification) so the component is drop-in reusable anywhere.
 */

import { App as AntApp } from "antd";

import { PosSellScreen } from "../components/pos/PosSellScreen";
import { PosThemeProvider } from "../components/pos/PosThemeProvider";

export const PosPage = () => (
  <PosThemeProvider>
    <AntApp>
      <PosSellScreen />
    </AntApp>
  </PosThemeProvider>
);
